export const iconFontAwesomeSecurityLock = (
	<i className="fa-solid fa-lock"></i>
);
